export const TERMS_CONDITIONS_CONFIGURATION_TAG_NAME = 'terms-conditions-configuration-container';
